import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Link, useHistory } from 'react-router-dom';

import './style.scss';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import logo from '../../../images/buriti-kindle.png';
import ACABAMENTO from '../../../images/ACABAMENTO.jpg';

import Header from '../../../components/header/index.js';
import Footer from '../../../components/footer/index.js';

import firebase from 'firebase/app';
import 'firebase/auth';
import FirebaseConfig from '../../../FirebaseConfig.js';

export default function Buriti() {
    const [dataColors, setDataColors] = useState([]);
    const [formatSize, setFormatSize] = useState({});
    const [formatId, setFormatId] = useState('');
    const [userIsLogged, setUserIsLogged] = useState(false);
    const [selectedColors, setSelectedColors] = useState([]);
    const [isValidated, setIsValidated] = useState(false);
    const [checkedBoxes, setCheckedBoxes] = useState(0);
    const [selectedModel, setSelectedModel] = useState('');
    const [selectedElasticColor, setSelectedElasticColor] = useState('');
    const [selectedSketchFinish, setSelectedSketchFinish] = useState('');
    const [clientNote, setClientNote] = useState('');
    const [displayModal, setDisplayModal] = useState('none');
    const [maxSlides, setMaxSlides] = useState(5);
    const [displayDimensionForms, setDisplayDimensionForms] = useState('none');
    const [currentStep, setCurrentStep] = useState(1);
    const [isCustomModel, setIsCustomModel] = useState(false);
    const [selectedCover, setSelectedCover] = useState('');

    const [values, setValues] = useState({});
    const [loading, setLoading] = useState(true);

    const [userDimensions, setUserDimensions] = useState({
        width: '',
        length: '',
        height: '',
    });

    const settings = {
        className: 'start',
        infinite: true,
        centerPadding: '60px',
        slidesToShow: maxSlides,
        swipeToSlide: true,
    };

    // Produtos a pronta entrega
    const [selectedStockProducts, setSelectedStockProducts] = useState([]);
    const [stockProducts, setStockProducts] = useState([]);

    useEffect(() => {
        const fetchStockProducts = async () => {
            try {
                const snapshot = await firebase
                    .database()
                    .ref('products')
                    .once('value');
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    // Transforma o objeto do Firebase num Array facilitando o .map()
                    const productsArray = Object.keys(data).map((key) => ({
                        id: key,
                        ...data[key],
                    }));
                    setStockProducts(productsArray);
                }
            } catch (error) {
                console.error('Erro ao buscar produtos adicionais:', error);
            }
        };

        fetchStockProducts();
    }, []);

    // Função para lidar com o clique no checkbox
    const toggleStockProduct = (product) => {
        setSelectedStockProducts((prevSelected) => {
            // Verifica se o produto já está selecionado
            const isAlreadySelected = prevSelected.some(
                (item) => item.id === product.id
            );

            if (isAlreadySelected) {
                // Se já estava, o cliente desmarcou (então removemos da lista)
                return prevSelected.filter((item) => item.id !== product.id);
            } else {
                // Se não estava, adicionamos na lista de selecionados
                return [...prevSelected, product];
            }
        });
    };

    const getFinalValue = () => {
        // Pega o valor base do papel/modelo selecionado
        const baseValue = parseFloat(selectedModel?.value || 0);

        // Soma os valores de todos os produtos a pronta entrega selecionados na etapa 7
        const additionalsValue = selectedStockProducts.reduce(
            (acc, product) => {
                return acc + parseFloat(product.value || 0);
            },
            0
        );

        return baseValue + additionalsValue;
    };

    useEffect(() => {
        const fetchModelsData = async () => {
            try {
                // busca os dados unificados direto do nó do modelo
                const snapshot = await firebase
                    .database()
                    .ref('models/buriti')
                    .once('value');

                if (snapshot.exists()) {
                    const modelData = snapshot.val();

                    // Extrai os formatos e os papéis do modelo
                    const formatsObj = modelData.formats || {};
                    const innerPapersObj = modelData.innerPapers || {};

                    // Filtra apenas os papéis ativos
                    const activePapers = Object.values(innerPapersObj).filter(
                        (p) => p.active
                    );

                    // Mapeia os formatos diretamente do que está cadastrado no banco
                    const formatosAtualizados = Object.values(formatsObj).map(
                        (formato) => {
                            // Mapeia os papéis ativos que possuem preço de Bloco Cheio (prices) para este formato
                            const tiposDePapelMapeados = activePapers
                                .filter(
                                    (paper) =>
                                        paper.prices &&
                                        paper.prices[formato.name] !== undefined
                                )
                                .map((paper) => ({
                                    name: paper.name,
                                    value: paper.prices[formato.name], // Puxa o preço do bloco cheio
                                }));

                            // Retorna o formato estruturado com os dados reais do banco + a array types
                            return {
                                ...formato, // Já traz name, basePrice e o objeto size completo
                                types: tiposDePapelMapeados,
                            };
                        }
                    );

                    // Atualiza o estado da tela sem precisar do 'initialValues' fixo
                    setValues({
                        name: modelData.name || 'Mandacaru',
                        formats: formatosAtualizados,
                    });
                }
            } catch (error) {
                console.error('Erro ao carregar dados do Mandacaru:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchModelsData();
    }, []);

    useEffect(() => {
        if (window.innerWidth < 820) {
            setMaxSlides(3);
        } else {
            setMaxSlides(5);
        }
    }, []);

    function handleSelectedModel(event) {
        let position = event.target.value;
        setSelectedModel(values.formats[position].types[0]);
        setFormatId(values.formats[position].id);

        if (
            values.formats[position].types[0].name ===
            'iPad/Tablet (Personalize o tamanho)'
        ) {
            setDisplayDimensionForms('flex');
        } else {
            setFormatSize(values.formats[position].size);
            setDisplayDimensionForms('none');
        }
    }

    function onAuthStateChanged(user) {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) setUserIsLogged(true);
        });
    }

    useEffect(() => {
        window.scrollTo(0, 0);

        if (!firebase.apps.length) firebase.initializeApp(FirebaseConfig);
        onAuthStateChanged();
    }, []);

    useEffect(() => {
        if (!firebase.apps.length) firebase.initializeApp(FirebaseConfig);

        var firebaseRef = firebase.database().ref('colors/');

        firebaseRef.on('value', (snapshot) => {
            if (snapshot.exists()) {
                var data = snapshot.val();
                var temp = Object.keys(data).map((key) => data[key]);
                setDataColors(temp);
            } else {
                console.log('No data available');
            }
        });
    }, []);

    function handleInputDimensionsChange(event) {
        const { name, value } = event.target;

        setUserDimensions({
            ...userDimensions,
            [name]: value,
        });
    }

    let history = useHistory();

    function addToCart() {
        const temp = JSON.parse(localStorage.getItem('products'));
        let listOfItems =
            temp !== null ? Object.keys(temp).map((key) => temp[key]) : [];

        const dataToSend = {
            model: 'Buriti',
            id: formatId,
            kindleModel: selectedModel.name,
            value: getFinalValue(),
            elasticColor: selectedElasticColor,
            sketchFinish: selectedSketchFinish,
            coverColors: selectedColors,
            clientNote: clientNote,
            selectedStockProducts: selectedStockProducts || [],
            size:
                selectedModel.name === 'iPad/Tablet (Personalize o tamanho)'
                    ? userDimensions
                    : formatSize,
        };

        // Adiciona o objeto principal na lista
        listOfItems.push(dataToSend);

        // Atualiza o localStorage e redireciona
        localStorage.setItem('products', JSON.stringify(listOfItems));
        history.push('/Carrinho');
    }

    function changeColor(event) {
        let isChecked;

        setTimeout(() => {
            isChecked = event.target.control.checked;

            if (isChecked) {
                event.target.style.backgroundColor = '#000';
            } else {
                event.target.style.backgroundColor = 'transparent';
            }
        }, 80);
    }

    const checkColor = (item, event) => {
        const isChecked = event.target.checked;

        if (isChecked) {
            setSelectedColors([
                ...selectedColors,
                {
                    name: item.colorName,
                    code: item.colorCode,
                },
            ]);

            setCheckedBoxes(checkedBoxes + 1);
        } else {
            const color = item.colorName;
            let index = selectedColors.findIndex(
                (element) => element.name === color
            );

            if (index !== -1) {
                selectedColors.splice(index, 1);
                setCheckedBoxes(checkedBoxes - 1);
            }
        }
    };

    useEffect(() => {
        if (
            selectedModel === '' ||
            selectedElasticColor === '' ||
            selectedSketchFinish === '' ||
            checkedBoxes > 1 ||
            checkedBoxes === 0
        ) {
            setIsValidated(false);
        } else {
            setIsValidated(true);
        }
    }, [
        selectedModel,
        selectedElasticColor,
        checkedBoxes,
        selectedSketchFinish,
    ]);

    function handleSelectedElasticColor(item, event) {
        setSelectedElasticColor(event);
    }

    function handleSelectedSketchFinish(event) {
        setSelectedSketchFinish(event.target.value);
    }

    function handleClientNote(event) {
        setClientNote(event.target.value);
    }

    function closeModal() {
        if (displayModal === 'none') setDisplayModal('flex');
        else {
            setDisplayModal('none');
        }
    }

    function handleNextStep() {
        if (currentStep <= 5) {
            setCurrentStep(currentStep + 1);
        }
    }
    function handlePreviousStep() {
        if (currentStep >= 2) {
            setCurrentStep(currentStep - 1);
        }
    }
    useEffect(() => {
        updateStepIndicator(currentStep);
        updateStepChoices(currentStep);
    }, [currentStep]);

    function updateStepIndicator(currentStep) {
        // retira a cor de ativo de todos pra garantir
        document.querySelectorAll('.stepTitle').forEach(function (step) {
            step.classList.remove('active-step');
        });

        // adiciona a cor de ativo no indicador do passo atual
        document
            .querySelector(`.title${currentStep}`)
            .classList.add('active-step');

        // mostra e esconde os botoes de avancar ou retroceder se estivar na primeira ou ultima pagina
        switch (currentStep) {
            case 1:
                // esconde o botao de voltar se estiver no primeiro passo
                document.querySelector('.btn.previous').classList.add('hide');
                break;
            case 2:
                // mostra novamente o botao de voltar neste passo
                document
                    .querySelector('.btn.previous')
                    .classList.remove('hide');
                break;
            case 5:
                // volta a mostrar o botao de avancar caso o usuario vá ao ultimo passo e volte
                document.querySelector('.btn.next').classList.remove('hide');
                break;
            case 6:
                // esconde o botao de proxima pagina se estiver no ultimo passo (pq ja tem o de adicionar ao carrinho)
                document.querySelector('.btn.next').classList.add('hide');
                break;
            default:
        }
    }

    function updateStepChoices(currentStep) {
        const steps = document.querySelectorAll('.steps');
        steps.forEach(function (step) {
            // esconde todas as outras divs
            step.classList.add('hide');
        });
        document.querySelector(`.step${currentStep}`).classList.remove('hide');

        // move a tela para cima para ficar melhor a percepcao do passo a passo
        if (currentStep !== 1) {
            window.scrollTo({
                top:
                    355 +
                    document.querySelector('.iframe-container').clientHeight,
                left: 0,
            });
        }
    }

    function handleSelectedModel(event) {
        let position = event.target.value;
        const selectedFormat = values.formats[position];

        setSelectedCover((prevCover) => {
            return selectedFormat.name;
        });

        if (selectedFormat.name === 'iPad/Tablet (Personalize o tamanho)') {
            setIsCustomModel(true);
            setDisplayDimensionForms('flex');
        } else {
            setIsCustomModel(false);
            setFormatSize(selectedFormat.size);
            setDisplayDimensionForms('none');
        }

        setSelectedModel(selectedFormat.types[0]);
        setFormatId(selectedFormat.id);
    }

    useEffect(() => {
        // Aqui, você pode realizar lógica com o valor atualizado de selectedCover
        console.log(selectedCover);
        // ...
    }, [selectedCover]);

    return (
        <main id='MainSketchbook'>
            <div
                style={{ display: displayModal }}
                role='dialog'
                className='divModal'
            >
                <div className='modalContent'>
                    <div className='sketchbookImgWrapper'>
                        <img src={logo} alt='' />
                    </div>

                    <span onClick={closeModal}>x</span>
                </div>
            </div>

            <Header />

            <section id='CreateSketchbookSection'>
                <div
                    className='iframe-container'
                    style={{ marginBottom: '1rem' }}
                >
                    <iframe
                        width='560'
                        height='315'
                        src='https://www.youtube.com/embed/d6vE5nG2PoY'
                        title='YouTube video player'
                        frameborder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowfullscreen
                    ></iframe>
                </div>
                <div className='logoWrapper'>
                    <img src={logo} alt='logo' />
                </div>

                <div className='textIntro'>
                    <h1>Monte seu Buriti</h1>
                    <h5>
                        Selecione as opções abaixo e monte seu cactus do seu
                        jeito
                    </h5>
                </div>

                <div id='steps-indicator'>
                    <div className='stepTitle title1 active-step'>
                        <h3>1: Modelo</h3>
                    </div>
                    <div className='stepTitle title2'>
                        <h3>2: Cor da Capa</h3>
                    </div>
                    <div className='stepTitle title3'>
                        <h3>3: Cor do Elástico</h3>
                    </div>
                    <div className='stepTitle title4'>
                        <h3>4: Acabamento</h3>
                    </div>
                    <div className='stepTitle title5'>
                        <h3>5: Adicionais</h3>
                    </div>
                    <div className='stepTitle title6'>
                        <h3>Resumo do Pedido</h3>
                    </div>
                </div>

                <div className='steps step1 full '>
                    <div className='textWrapper'>
                        <div className='textBackground'>
                            <h2>Modelo do Dispositivo</h2>
                        </div>
                    </div>
                    <fieldset>
                        <label htmlFor='kindleModel'>Selecione o modelo</label>

                        <select
                            onChange={handleSelectedModel}
                            className='kindleModel'
                            defaultValue='0'
                        >
                            <option value='0' disabled>
                                Modelo do seu aparelho
                            </option>

                            {values.formats?.map((format, index) => {
                                if (
                                    !format.types ||
                                    format.types.length === 0
                                ) {
                                    return null;
                                }
                                return (
                                    <option value={index} key={index}>
                                        {format.name}
                                    </option>
                                );
                            })}
                        </select>
                    </fieldset>

                    <fieldset
                        className='userModel'
                        style={{ display: displayDimensionForms }}
                    >
                        <label htmlFor='userModel'>
                            Insira as dimensões abaixo
                        </label>

                        <form className='userModel'>
                            <input
                                id='width'
                                name='width'
                                type='number'
                                onChange={handleInputDimensionsChange}
                                placeholder='Largura'
                            />
                            <input
                                id='length'
                                name='length'
                                type='number'
                                onChange={handleInputDimensionsChange}
                                placeholder='Comprimento'
                            />
                            <input
                                id='height'
                                name='height'
                                type='number'
                                onChange={handleInputDimensionsChange}
                                placeholder='Altura'
                            />
                        </form>
                    </fieldset>
                </div>

                {/*aparentemente o passo 2 não precisa do width: 100%  (classe full)*/}
                <div className='steps step2 hide'>
                    <div className='textWrapper'>
                        <div className='textBackground'>
                            <h2>Cor da capa</h2>
                        </div>

                        <p>
                            Selecione <strong>uma</strong> cor. Arraste para o
                            lado para conferir todas as opções.
                        </p>
                    </div>

                    <div className='sliderColors'>
                        <Slider {...settings}>
                            {dataColors.map((item, index) =>
                                item.models?.includes('buriti') &&
                                item.categories?.includes('cover') &&
                                // não mostra as capas ilustres, caso seja cadastrada errado, pq nao esta disponivel pro buriti
                                !item.isIlustres ? (
                                    <div className='cardColor' key={index}>
                                        <label
                                            htmlFor={index}
                                            onClick={(event) =>
                                                changeColor(event)
                                            }
                                        />

                                        {item.image ? (
                                            <div
                                                key={item.id}
                                                className='colorBox'
                                            >
                                                <img
                                                    draggable='false'
                                                    src={item.image}
                                                    alt='cor'
                                                />
                                            </div>
                                        ) : (
                                            <div
                                                key={item.id}
                                                style={{
                                                    backgroundColor:
                                                        item.colorCode,
                                                }}
                                                className='colorBox'
                                            >
                                                <p>{item.colorCode}</p>
                                            </div>
                                        )}

                                        <div className='colorName'>
                                            <p>{item.colorName}</p>

                                            <input
                                                type='checkbox'
                                                value={index}
                                                id={index}
                                                onChange={(event) =>
                                                    checkColor(item, event)
                                                }
                                                style={{
                                                    accentColor: item.colorCode,
                                                }}
                                            />
                                        </div>
                                    </div>
                                ) : null
                            )}
                            {dataColors.map((item, index) =>
                                item.availableSizes && selectedCover ? (
                                    item.models?.includes('buriti') &&
                                    item.categories?.includes('cover') &&
                                    item.availableSizes?.includes(
                                        selectedCover
                                    ) ? (
                                        <div className='cardColor' key={index}>
                                            <label
                                                htmlFor={index}
                                                className='coverColorLabel'
                                                onClick={(event) =>
                                                    changeColor(event)
                                                }
                                            />

                                            {item.image ? (
                                                <div
                                                    key={item.id}
                                                    className='colorBox'
                                                >
                                                    <img
                                                        draggable='false'
                                                        src={item.image}
                                                        alt='cor'
                                                    />
                                                </div>
                                            ) : (
                                                <div
                                                    key={item.id}
                                                    style={{
                                                        backgroundColor:
                                                            item.colorCode,
                                                    }}
                                                    className='colorBox'
                                                >
                                                    <p>{item.colorCode}</p>
                                                </div>
                                            )}

                                            <div className='colorName'>
                                                <p>
                                                    <span
                                                        style={{
                                                            color: 'green',
                                                        }}
                                                    >
                                                        (+ R$
                                                        {item.aditionalPrice})
                                                    </span>{' '}
                                                    {item.colorName}
                                                </p>

                                                <input
                                                    type='checkbox'
                                                    value={index}
                                                    id={index}
                                                    onChange={(event) =>
                                                        checkColor(item, event)
                                                    }
                                                    style={{
                                                        accentColor:
                                                            item.colorCode,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ) : null
                                ) : null
                            )}
                        </Slider>
                    </div>
                </div>
                {/*aparentemente o passo 3 tbm não precisa do width: 100%  */}
                <div className='steps step3 hide'>
                    <section id='RadioSelectionColors'>
                        <div className='boxColor'>
                            <div className='textWrapper'>
                                <div className='textBackground'>
                                    <h2>Cor do elástico</h2>
                                </div>

                                <p>
                                    Selecione <strong>uma</strong> cor
                                </p>
                            </div>

                            <div className='elasticColorWrapper'>
                                {dataColors.map((item, index) =>
                                    item.models?.includes('buriti') &&
                                    item.categories?.includes('elastic') ? (
                                        <div
                                            className='colorWrapper'
                                            key={index}
                                        >
                                            {item.image ? (
                                                <div className='elasticColor'>
                                                    <img
                                                        src={item.image}
                                                        alt='cor do elástico'
                                                    />
                                                </div>
                                            ) : (
                                                <div
                                                    style={{
                                                        backgroundColor:
                                                            item.colorCode,
                                                    }}
                                                    className='elasticColor'
                                                />
                                            )}

                                            <input
                                                type='radio'
                                                onClick={(event) =>
                                                    handleSelectedElasticColor(
                                                        event,
                                                        item,
                                                        index
                                                    )
                                                }
                                                name='selectedElasticColor'
                                                key={item.id}
                                                value={item.name}
                                                style={{
                                                    accentColor: item.colorCode,
                                                }}
                                            />
                                        </div>
                                    ) : null
                                )}
                            </div>
                        </div>
                    </section>
                </div>

                <div className='steps step4 full hide'>
                    <div className='textWrapper'>
                        <div className='textBackground'>
                            <h2>Tipo de Acabamento</h2>
                        </div>
                        <img
                            src={ACABAMENTO}
                            alt='Demonstração do acabamento das bordas do sketchbook, podendo ser arredondado ou reto'
                        />
                    </div>

                    <fieldset>
                        <label htmlFor='SketchFinish'>
                            Selecione o tipo de acabamento nas bordas
                        </label>

                        <select
                            onChange={(event) =>
                                handleSelectedSketchFinish(event)
                            }
                            className='SketchFinish'
                            defaultValue='0'
                        >
                            <option value='0' disabled>
                                Tipo de Acabamento
                            </option>
                            <option value='Reto'>Reto</option>
                            <option value='Arredondado'>Arredondado</option>
                        </select>
                    </fieldset>
                </div>

                <div className='steps step5 full hide adicionais-container'>
                    <div className='textWrapper'>
                        <div className='textBackground'>
                            <h2>Adicionais (Pronta Entrega)</h2>
                        </div>
                    </div>

                    <fieldset className='adicionais-fieldset'>
                        <label htmlFor='SketchFinish'>
                            Gostaria de adicionar um produto a pronta entrega ao
                            seu pedido final?
                            <div className='skipStockProducts'>
                                <Link
                                    to='#stockProductsSection'
                                    onClick={(e) => handleNextStep()}
                                >
                                    Não quero adicionais
                                </Link>
                            </div>
                        </label>

                        {stockProducts.length > 0 ? (
                            <div
                                className='produtos-grid'
                                id='stockProductsSection'
                            >
                                {stockProducts
                                    // Filtra para exibir apenas produtos com estoque disponível
                                    .filter(
                                        (product) => Number(product.stock) > 0
                                    )
                                    .map((product) => {
                                        // Verifica se este produto específico está selecionado
                                        const isSelected =
                                            selectedStockProducts.some(
                                                (item) => item.id === product.id
                                            );

                                        return (
                                            <div
                                                key={product.id}
                                                className={`produto-card ${
                                                    isSelected ? 'selected' : ''
                                                }`}
                                                onClick={() =>
                                                    toggleStockProduct(product)
                                                }
                                            >
                                                {/* Imagem do Produto */}
                                                {product.productImage ? (
                                                    <img
                                                        src={
                                                            product.productImage
                                                        }
                                                        alt={
                                                            product.productName
                                                        }
                                                        className='produto-img'
                                                    />
                                                ) : (
                                                    <div className='produto-img-placeholder' />
                                                )}

                                                {/* Informações do Produto */}
                                                <div className='produto-info'>
                                                    <span className='produto-titulo'>
                                                        {product.productName}
                                                    </span>

                                                    {product.description && (
                                                        <span className='produto-desc'>
                                                            {
                                                                product.description
                                                            }
                                                        </span>
                                                    )}

                                                    <span className='produto-preco'>
                                                        R${' '}
                                                        {parseFloat(
                                                            product.value || 0
                                                        ).toLocaleString(
                                                            'pt-BR',
                                                            {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2,
                                                            }
                                                        )}
                                                    </span>
                                                </div>

                                                {/* Botão de Adicionar / Removido */}
                                                <button
                                                    type='button'
                                                    className={`btn-add ${
                                                        isSelected
                                                            ? 'btn-remove'
                                                            : ''
                                                    }`}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // Evita disparar dois cliques
                                                        toggleStockProduct(
                                                            product
                                                        );
                                                    }}
                                                >
                                                    {isSelected ? '✓' : '+'}
                                                </button>
                                            </div>
                                        );
                                    })}
                            </div>
                        ) : (
                            <p className='loading-text'>
                                Carregando produtos adicionais...
                            </p>
                        )}
                    </fieldset>
                </div>

                <div className='steps step6 full hide'>
                    <div className='additionalInfos'>
                        <label htmlFor='additionalInfos'>
                            Informações adicionais <strong>(opcional)</strong>
                        </label>

                        {selectedModel.name === 'iPad/Tablet' ? (
                            <p>
                                Se preferir, conte-nos aqui em baixo o modelo do
                                seu iPad/Tablet
                            </p>
                        ) : (
                            ''
                        )}

                        <textarea
                            type='text'
                            name='additionalInfos'
                            id='additionalInfos'
                            onChange={handleClientNote}
                        />

                        {isValidated ? (
                            <>
                                <div className='productInfosWrapper'>
                                    <h1>Seu sketchbook</h1>

                                    <ul>
                                        <li>
                                            <strong>Modelo: </strong>
                                            {selectedModel.name}
                                        </li>

                                        {isCustomModel && (
                                            <li>
                                                <strong>Dimensões: </strong>
                                                Largura: {
                                                    userDimensions.width
                                                }{' '}
                                                cm, Comprimento:{' '}
                                                {userDimensions.length} cm,
                                                Altura: {userDimensions.height}{' '}
                                                cm
                                            </li>
                                        )}

                                        <li>
                                            <strong>Cor da capa: </strong>
                                            {selectedColors.map(
                                                (color, index) => {
                                                    return (
                                                        <span key={index}>
                                                            {(index
                                                                ? ' + '
                                                                : '') +
                                                                color.name}
                                                        </span>
                                                    );
                                                }
                                            )}
                                        </li>

                                        <li>
                                            <strong>Cor do elástico: </strong>
                                            {selectedElasticColor.colorName}
                                        </li>
                                        <li>
                                            <strong>
                                                Tipo de Acabamento:{' '}
                                            </strong>
                                            {selectedSketchFinish}
                                        </li>

                                        {selectedStockProducts.length > 0 && (
                                            <li>
                                                <strong>
                                                    Produtos a pronta entrega
                                                    selecionado:{' '}
                                                </strong>

                                                <ul
                                                    style={{
                                                        margin: '5px 0 0 15px',
                                                        padding: 0,
                                                    }}
                                                >
                                                    {selectedStockProducts.map(
                                                        (product) => (
                                                            <li
                                                                key={product.id}
                                                            >
                                                                {
                                                                    product.productName
                                                                }{' '}
                                                                — R${' '}
                                                                {product.value}
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </li>
                                        )}
                                    </ul>

                                    <h3>
                                        Valor do sketchbook: R${' '}
                                        {getFinalValue()}
                                    </h3>

                                    <button onClick={() => addToCart()}>
                                        Adicionar ao carrinho
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p>
                                    Você deve selecionar{' '}
                                    <strong>todas as opções</strong> antes de
                                    finalizar seu sketchbook
                                </p>
                            </>
                        )}
                    </div>
                </div>

                <div id='btns'>
                    <button
                        className='btn previous hide'
                        onClick={(e) => handlePreviousStep()}
                    >
                        Etapa Anterior
                    </button>
                    <button
                        className='btn next'
                        onClick={(e) => handleNextStep()}
                    >
                        Próxima Etapa
                    </button>
                </div>
            </section>

            <Footer />
        </main>
    );
}
